import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-bpi.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-bpi.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationService } from "../../../view-application.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { take, takeUntil } from "rxjs/operators";
import { ViewApplicationDetailsBpiConstants } from "./view-application-details-bpi.constants";
let ViewApplicationDetailsBpiComponent = class ViewApplicationDetailsBpiComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    appController;
    viewApplicationService;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsBpiConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    saveBtnPlaceholder = ViewApplicationDetailsBpiConstants.SAVE_BUTTON_PLACEHOLDER;
    descriptionLabel = ViewApplicationDetailsBpiConstants.DESCRIPTION_LABEL;
    referenceNumberLabel = ViewApplicationDetailsBpiConstants.REFERENCE_NUMBER_LABEL;
    bpamsReferenceNumberLabel = ViewApplicationDetailsBpiConstants.BPAMS_REFERENCE_NUMBER_LABEL;
    descriptionFormControlName = ViewApplicationDetailsBpiConstants.DESCRIPTION_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsBpiConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    bpamsReferenceNumberFormControlName = ViewApplicationDetailsBpiConstants.BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    application;
    getApplicationSaveObservableSubscription;
    getStepMetaObservableSubscription;
    getLookupsObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, appController, viewApplicationService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.viewApplicationService = viewApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
        this.getApplication();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsBpiConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            this.detailsForm.get(this.descriptionFormControlName).setValue(this.application.description);
            this.detailsForm.get(this.bpamsReferenceNumberFormControlName).setValue(this.application.bpamsReferenceNumber);
            this.detailsForm.get(this.referenceNumberControlName).setValue(this.application.referenceNumber);
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.bpamsReferenceNumberFormControlName).disable();
            this.detailsForm.get(this.referenceNumberControlName).disable();
            this.detailsForm.updateValueAndValidity();
            this.changeDetectorRefs.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ViewApplicationService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsBpiComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-bpi",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsBpiComponent);
export { ViewApplicationDetailsBpiComponent };
